export default "__VITE_ASSET__CeL9sCfP__"